export const SOCIAL_IDS = [
    'Instagram',
    'Facebook',
    'Threads',
    'Tiktok',
    'Youtube',
] as const;
